export const defaultVisibleSection = { start: 0, end: 0 };

export const ARTIFACT_GENERATION_TYPE = { SINGLE_FILE: 'single_file' };
export const ARTIFACTS_REMOVED_ARTIFACT = 'ARTIFACTS_REMOVED_ARTIFACT';
export const ARTIFACTS_SET_ARTIFACT_URL = 'ARTIFACTS_SET_ARTIFACT_URL';
export const UPDATED_ARTIFACT = 'UPDATED_ARTIFACT';
export const RECEIVE_ARTIFACTS = 'RECEIVE_ARTIFACTS';
export const RECEIVE_RELEASE = 'RECEIVE_RELEASE';
export const RECEIVE_RELEASES = 'RECEIVE_RELEASES';
export const RELEASE_REMOVED = 'RELEASE_REMOVED';
export const SHOW_REMOVE_DIALOG = 'SHOW_REMOVE_DIALOG';
export const SELECTED_ARTIFACT = 'SELECTED_ARTIFACT';
export const SELECTED_RELEASE = 'SELECTED_RELEASE';
export const SET_RELEASES_LIST_STATE = 'SET_RELEASES_LIST_STATE';
export const rootfsImageVersion = 'rootfs-image.version';

export const softwareTitleMap = { [rootfsImageVersion]: { title: 'Root filesystem', priority: 0, key: rootfsImageVersion } };
